<template>
  <div>
    <div class="container">
      <ul class="ul-new" v-if="newList.length>0">
        <li v-for="(item,index) in newList" :key="index" @click="goArticleDetail(item)">
          <div class="new-item">
            <span id="title">{{item.infoTitle}}</span>
            <span id="time" v-if="item.createTime">{{item.createTime.substring(0,10)}}</span>
          </div>
        </li>
      </ul>
      <el-pagination v-if="total > pageSize" class="pagination" background layout="prev, pager, next" :current-page="currentPageNo"
          @current-change="pageChange" :total="total">
        </el-pagination>
        <div class="empty-container" v-if="!loading && (!newList || newList.length == 0)">
          <span>暂时没有课堂</span>
        </div>
    </div>
  </div>

</template>

<script>
export default {
  data(){
    return {
      pageSize:10,
      currentPageNo: 1,
      total: 0,
      newList:[],
      loading: true,
    }
  },
  created(){
    this.getNews()
  },
  methods:{
    getNews(){
      this.loading = true;
      this.wjtHttp.get(this,'/api/home/v1/course?pageNum='+this.currentPageNo+'&pageSize='+this.pageSize,{},false,(res)=>{
        var data = res.data
        this.loading = false;
        if(data.code == 200){
          this.newList = data.rows
          this.total = data.total
        }else{
            this.$message({
                message:(data.msg&&data.msg.length > 0)?data.msg:'课堂获取异常，请联系管理员',
                type:'error'
            })
        }
      })
    },
    pageChange(pageNo) {
        this.currentPageNo = pageNo
        this.getNews()
    },
    goArticleDetail(item){
      if(!this.utils.isEmptyStr(item.infoUrl)){
        window.open(item.infoUrl, '_blank')
      }
    }
  }
}
</script>

<style scoped>
.container{
  width: 800px;
  min-height: 520px;
  margin: auto auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 30px auto;
}
.ul-new{
  list-style: square;
  width: 100%;
}
.ul-new>li{
  width: 100%;
  height: 50px;
  cursor: pointer;
}
.new-item{
  height: 100%;
  width: 100%;
  align-items: center;
  display: flex;
  flex-direction: row;
  color: #333333;
  font-size: 18px;
  border-bottom-style: solid;
  border-color: #E6E6E6;
  border-width: 1px;
}
.new-item:hover{
  color: #156098;
}
#title{
  width: 70%;
  text-align: left;
}
#time{
  width: 30%;
  text-align: right;
}
.empty-container {
  width: 100%;
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.empty-container>span {
  font-size: 20px;
  color: #AEAEAE;
}
.pagination {
  margin-top: 20px;
}
</style>
